import Press from "./Press";

export { Page }

function Page() {
  return <Press />;
}